import { lazy } from 'react';

// React.lazy that survives a deploy. Used for route pages (App.js) and heavy
// on-demand UI such as the Import dialog (FloatingAddButton).
// After a deploy the old hashed chunk files are gone, so a tab opened before the
// deploy fails the first time it navigates to a page it hasn't loaded yet — Nginx's
// try_files fallback answers the missing .js with index.html. Reload once to pick
// up the new build; the sessionStorage flag stops a genuinely broken chunk from
// reloading forever. Storage access is guarded because it can throw (private mode,
// blocked site data), in which case this just rethrows like a plain lazy() would.
const RELOAD_FLAG = 'chunk-reload-attempted';
export const lazyWithReload = (factory) => lazy(async () => {
  try {
    const module = await factory();
    try { window.sessionStorage.removeItem(RELOAD_FLAG); } catch { /* storage unavailable */ }
    return module;
  } catch (error) {
    let alreadyTried = true;
    try {
      alreadyTried = window.sessionStorage.getItem(RELOAD_FLAG) === '1';
      if (!alreadyTried) window.sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch { /* storage unavailable: fall through and rethrow */ }
    if (!alreadyTried) {
      window.location.reload();
      return new Promise(() => {}); // keep Suspense's fallback up until the reload lands
    }
    throw error;
  }
});
